// Module
var code = "<!-- ko descendantsComplete: $component.onRender.bind($component) -->\n\n<!-- ko template: { nodes: $componentTemplateNodes } -->\n<!-- /ko -->\n\n<span class=\"foquz-chars-counter__value\" data-bind=\"text: count\"></span>\n\n<!-- /ko -->\n";
// Exports
module.exports = code;